(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/components/widget-fallbacks/advertise-create-team.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/components/widget-fallbacks/advertise-create-team.js');

'use strict';

const {
  Grid,
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  routes
} = svs.arena.constants;
const AdvertiseCreateTeam = () => {
  const history = ReactRouterDOM.useHistory();
  return React.createElement("div", {
    className: "main-content-constrained"
  }, React.createElement(Grid, {
    className: "align-center justify"
  }, React.createElement(GridRow, {
    className: "padding-h-1 u-flex-justify-content-center",
    gutter: "0"
  }, React.createElement(GridCol, {
    className: "u-text-center",
    md: "4",
    sm: "8",
    am: "6",
    xs: "12"
  }, React.createElement(Icon, {
    className: "margin-top-4 margin-bottom-2",
    icon: "spela-tillsammans",
    size: "1000"
  }), React.createElement("h2", {
    className: "h1"
  }, "Dr\xF6m tillsammans - Spela tillsammans!"), React.createElement("p", {
    className: "margin-bottom-2 line-height-150"
  }, "N\xE4r du spelar tillsammans med andra h\xE5ller ni den gemensamma dr\xF6mmen vid liv. Och det b\xE4sta med dr\xF6mmar \xE4r att de kan g\xE5 i uppfyllelse. Spela tillsammans p\xE5 Eurojackpot, Keno, Lotto med Joker, Vikinglotto och Rubbet."), React.createElement(Button, {
    block: true,
    focus: true,
    onClick: () => history.push(routes.TEAMS_CREATE)
  }, "Skapa ett lag")))));
};
svs.arena.shared.components.widgetFallbacks.AdvertiseCreateTeam = AdvertiseCreateTeam;

 })(window);